import type {
  AsyncEcho,
  HeartbeatRequest,
  HeartbeatResponse,
  LocationsResponse,
  UploadDeviceLogs,
} from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";

export function heartbeat(
  transport: Transport,
  { workspaceId, ...body }: { workspaceId: string } & HeartbeatRequest,
): Promise<HeartbeatResponse> {
  return operations.postWorkspacesHeartbeat(transport, { workspaceId, body });
}

export function getLocations(
  transport: Transport,
  { workspaceId, membershipIds }: { workspaceId: string; membershipIds: string[] },
): Promise<LocationsResponse> {
  return operations.postWorkspacesLocations(transport, { workspaceId, body: { membershipIds } });
}

export function uploadLogs(transport: Transport, body: UploadDeviceLogs): Promise<void> {
  return operations.postLogs(transport, { body });
}

export function asyncEcho(transport: Transport, { data }: { data: string }): Promise<AsyncEcho> {
  return operations.postEchoAsync(transport, { body: { data } });
}
